export { default as BrowserCheck } from './BrowserCheck';
export { default as HomeNewTable } from './HomeNewTable/HomeNewTable';
export { default as HomePageBlog } from './HomePageBlog/HomePageBlog';
export { default as HomePageContainer } from './HomePageContainer/HomePageContainer';
export { default as HomePageSearchWrapper } from './HomePageContainer/HomePageSearchWrapper';
export { default as HomePageRoadMap } from './HomePageRoadMap';
export { default as HomePageVideoTab } from './HomePageSectionLesson/HomePageSectionLesson';
export { default as HomeV2SliderContainer } from './HomeV2Slider/homeV2SliderContainer';
export { default as HomeNewCounseling } from './NewHomeConsultation/HomeNewCounseling';
export { default as InstallPWA } from './PWA/InstallPWA';
